import { EntityIdentifierHelper } from '@fairandsmart/types';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  FsOrgState, LoadingState, TaskPanelTab, TaskState,
} from '../../../reducers';
import { TaskActions, TaskActionTypes } from './task.actions';

const initialState: TaskState = {
  panelOpened: false,
  panelTab: TaskPanelTab.USER_TASKS,
  userTasks: null,
  userTasksState: LoadingState.INIT,
  userTodos: null,
  refTasks: null,
  refTasksState: LoadingState.INIT,
  currentRef: null,
};

export function TaskReducer(state: TaskState = initialState, action: TaskActions = null): TaskState {
  switch (action.type) {
    case TaskActionTypes.CloseTaskPanel:
      return { ...state, panelOpened: false };

    case TaskActionTypes.SelectUserTab:
    case TaskActionTypes.ShowUserTasks:
      return { ...state, panelOpened: true, panelTab: TaskPanelTab.USER_TASKS };

    case TaskActionTypes.SelectRefTab:
    case TaskActionTypes.ShowRequestTasks:
      return { ...state, panelOpened: true, panelTab: TaskPanelTab.REF_TASKS };

    case TaskActionTypes.LoadUserTasks:
      return { ...state, userTasksState: LoadingState.LOADING };

    case TaskActionTypes.LoadUserTasksSuccess:
      return { ...state, userTasks: action.payload.response, userTasksState: LoadingState.LOADED };

    case TaskActionTypes.LoadUserTasksFailure:
      return { ...state, userTasksState: action.payload.response.error };

    case TaskActionTypes.LoadRefTasks:
      return { ...state, refTasksState: LoadingState.LOADING };

    case TaskActionTypes.LoadRefTasksSuccess:
      return {
        ...state, refTasks: action.payload.response, currentRef: action.payload.refIdentifier, refTasksState: LoadingState.LOADED,
      };

    case TaskActionTypes.LoadRefTasksFailure:
      return { ...state, refTasksState: action.payload.response.error };

    case TaskActionTypes.QuitEntityPage:
      return {
        ...state, refTasks: null, currentRef: null, refTasksState: LoadingState.INIT, panelTab: TaskPanelTab.USER_TASKS,
      };

    case TaskActionTypes.CountUserTasksToDoSuccess:
      return { ...state, userTodos: action.payload.count };

    case TaskActionTypes.CountUserTasksToDoFailure:
      return { ...state, userTodos: -1 };

    default:
      return state;
  }
}

export const taskFeature = createFeatureSelector<FsOrgState, TaskState>('task');

export const selectUserTask = createSelector(
  taskFeature,
  (state: TaskState) => ({
    collection: state.userTasks,
    state: state.userTasksState,
  }),
);

export const selectRefTasks = createSelector(
  taskFeature,
  (state: TaskState) => ({
    reference: state.currentRef,
    type: state.currentRef ? EntityIdentifierHelper.extractType(state.currentRef) : null,
    collection: state.refTasks,
    state: state.refTasksState,
  }),
);

export const userTodos = createSelector(
  taskFeature,
  (state: TaskState) => state.userTodos,
);

export const taskPanelOpened = createSelector(
  taskFeature,
  (state: TaskState) => state.panelOpened,
);

export const taskPanelTab = createSelector(
  taskFeature,
  (state: TaskState) => ({
    current: state.panelTab,
    type: state.currentRef ? EntityIdentifierHelper.extractType(state.currentRef) : null,
  }),
);
